import { Feature } from '@tencent/workbench';
import { BaseFillFeature } from '@framework/workbench/drawer/ui/fill/base/base-fill-feature';
import { FillType, FillTypes } from '@framework/workbench/drawer/ui/fill/constants';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { IFillTypeShower } from '@tencent/drawing-drawer-components';

@Feature()
export class FillTypeShower extends BaseFillFeature implements IFillTypeShower {
    public constructor() {
        super();
    }

    public getRadioOptions = () => {
        const fillTypes: {key: string, content: string}[] = [];
        const propertyMenu = this.getPropertyMenu();
        let isSlideBg = false;
        propertyMenu?.items?.forEach((item) => {
            if (item.id === ActionType.FILLCOLOR) {
                isSlideBg = !!item?.isSlideBg;
            }
        });
        const { fillColor } = this;
        FillTypes.forEach((item) => {
            if (this.needFilterFillType(item, isSlideBg, fillColor?.pattFill)) {
                // 设置幻灯片背景没有无填充
            } else {
                fillTypes.push(item);
            }
        });
        return fillTypes;
    };

    public getCurrentFillType = () => {
        let { fillType } = this;
        if (typeof fillType === 'undefined') {
            fillType = FillType.SOLID_FILL;
        }
        return fillType;
    };

    /**
     * FillTypes选项过滤
     */
    private needFilterFillType = (item, isSlideBg, pattFill) => (item.key === FillType.NO_FILL && isSlideBg)
        || (item.key === FillType.PATT_FILL && !pattFill);
}
